import React from 'react';
import './Gewichtsberechnung.css';
import { calculateGewichtEcke, calculateGewichtProfil, calculateLaengeRahmenprofil, calculateLaengsteSeite, calculateProfilgroesse, calculateRahmenprofilgewicht } from '../calculations/weight';


class Rahmenprofilgewichtberechnung extends React.Component {
  constructor(props) {
      super(props);
      //this.handleChange = this.handleChange.bind(this);
      this.state = {
          value: null,
      };
  }

  _Rahmengewicht(){
        //Gibt die Masse des Rahmens zurück
        let masseRahmen = calculateRahmenprofilgewicht(this.props);
        this.props.handleRahmenprofilgewichtChange(masseRahmen);
        return masseRahmen;
  }

  _Laenge_Rahmenprofil(){
      return calculateLaengeRahmenprofil(this.props);

  }
  _Gewicht_Ecke(){
      return calculateGewichtEcke(this.props);
  }
  _Gewicht_Profil(){
      return calculateGewichtProfil(this.props);
  }

  _Profilgroesse(){
      let profil = calculateProfilgroesse({ ...this.props, CheckedAnschlussprofil: false });
      this.props.CalculatedAnschlussprofil(profil);
      if(this.props.CheckedAnschlussprofil){
          return this.props.SelectedAnschlussprofil;
      }
      else{
          return profil;
      }
  }
  _LaengsteSeite(){
       return calculateLaengsteSeite([this.props.Lueftungskanalbreite,this.props.Lueftungskanalhoehe]);
  }


  render() {
      this._Rahmengewicht();
      return null;//his._Lueftungsgehaeusegewicht().toFixed(2);//this._Blechdicke();//this._Flaeche_Luefungskanal();
  }
}
export default Rahmenprofilgewichtberechnung;
